/**
 * Cookie banner enhancements
 *
 * Shopify injects its cookie banner (#shopify-pc__banner) and, once opened,
 * the preferences dialog (#shopify-pc__prefs) as direct children of <body>.
 * We can't edit their markup, so this wraps each action button's label in the
 * same structure the theme's FlipButton expects (see wholesale-form.liquid)
 * to give them the "Add to bag" letter-flip hover. Styling lives in
 * src/styles/components/cookie-banner.scss.
 */

import FlipButton from '../snippets/flipbutton';

const BUTTON_SELECTOR = [
  '#shopify-pc__banner__btn-accept',
  '#shopify-pc__banner__btn-decline',
  '.shopify-pc__prefs__header-actions button',
].join(',');

function enhanceButtons() {
  document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
    if (button.dataset.flipReady) return;
    const text = button.textContent.trim();
    if (!text) return;

    button.dataset.flipReady = 'true';

    const wrap = document.createElement('span');
    wrap.className = 'position-relative d-inline-block';
    const label = document.createElement('span');
    label.className = 'js-flipbutton';
    label.textContent = text;
    wrap.appendChild(label);
    button.replaceChildren(wrap);

    new FlipButton(label, { fade: false });
  });
}

export function initCookieBanner() {
  enhanceButtons();

  // Banner and dialog are inserted asynchronously (and the dialog only on
  // first open), always straight under <body>, so a shallow observer is enough.
  new MutationObserver(enhanceButtons).observe(document.body, { childList: true });
}
